import React from "react";
import PropTypes from "prop-types";

import ChargingPinPublic from "./../../../client_customizations/assets/images/icons/charger-pin-public.svg";
import ChargingPinHighPower from "./../../../client_customizations/assets/images/icons/charger-pin-high-power.svg";
import ChargingPinDefault from "./../../../client_customizations/assets/images/icons/charger-pin-private.svg";
import isSuperChargingStation from "../../../utils/predicates/isSuperChargingStation";
import { FormattedMessage } from "react-intl";

import "./ChargingStationsMapLegend.scss";

const ChargingStationsMapLegend = ({ chargingStations }) => {
  const hasSuperChargerStations = (chargingStations || []).some((station) =>
    isSuperChargingStation(station)
  );

  return (
    <div className="legend ChargingStationsMapLegend">
      <div className="charger-type">
        <img src={ChargingPinPublic} alt="Public Charging Stations Pin" />
        <b>
          <FormattedMessage
            id="chargingStations.mapLegend.public"
            defaultMessage="Public Stations"
            description="Public Stations Title"
          />
        </b>
        <br />
        <span>
          <FormattedMessage
            id="chargingStations.mapLegend.publicSubtext"
            defaultMessage="Installed by business or government"
            description="Public Stations subtitle"
          />
        </span>
      </div>
      {hasSuperChargerStations && (
        <div className="charger-type">
          <img src={ChargingPinHighPower} alt="High Power Charging Pin" />

          <b>
            <FormattedMessage
              id="chargingStations.mapLegend.high"
              defaultMessage="High Power Stations"
              description="High Power Stations Title"
            />
          </b>
          <br />
          <span>
            <FormattedMessage
              id="chargingStations.mapLegend.highSubtext"
              defaultMessage="DC fast chargers or superchargers"
              description="High Stations subtitle"
            />
          </span>
        </div>
      )}
      <div className="charger-type">
        <img src={ChargingPinDefault} alt="Other Charging Stations Pin" />

        <b>
          <FormattedMessage
            id="chargingStations.mapLegend.other"
            defaultMessage="Other Types of Stations"
            description="Other Types of Stations Title"
          />
        </b>
        <br />
        <span>
          <FormattedMessage
            id="chargingStations.mapLegend.private"
            defaultMessage="Private Stations"
            description="Private Stations Title"
          />
        </span>
      </div>
    </div>
  );
};

ChargingStationsMapLegend.propTypes = {
  chargingStations: PropTypes.array,
};

ChargingStationsMapLegend.defaultProps = {
  chargingStations: [],
};

export default ChargingStationsMapLegend;
